import { Flame, Users, Globe2 } from "lucide-react";

const TOKEN_3D =
  "https://images.unsplash.com/photo-1660062993659-3974d11f9d90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxzb2xhbmElMjBjcnlwdG9jdXJyZW5jeSUyMDNkJTIwcmVuZGVyfGVufDB8fHx8MTc4MTM5MzUwNnww&ixlib=rb-4.1.0&q=85";

const PILLARS = [
  {
    icon: Flame,
    title: "Meme Energy",
    body: "Pure internet-native hype. $LA28 lives in screenshots, replies, and shitposts.",
  },
  {
    icon: Users,
    title: "Army Culture",
    body: "The LA28 Army is the brand. No team, no founders — only the community.",
  },
  {
    icon: Globe2,
    title: "Countdown Narrative",
    body: "A global cultural era leading into 2028. Every day the timer ticks, the meme grows.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 sm:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
        {/* LEFT — copy */}
        <div>
          <div className="font-mono text-xs tracking-[0.32em] text-[#00F0FF] mb-5">
            // 01 · THE MISSION
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1] text-white">
            A token built <br />
            by the army, <br />
            <span className="text-[#FFD700] glow-gold">for the army.</span>
          </h2>
          <p className="mt-6 text-white/70 leading-relaxed max-w-md">
            $LA28 is a fair-launch Solana meme token on{" "}
            <span className="text-[#FFD700] font-semibold">pump.fun</span>. No
            utility decks pretending to be tech. Just culture, hype, and a
            countdown the entire internet is going to feel.
          </p>
          <p className="mt-4 text-white/50 leading-relaxed max-w-md">
            The LA28 Army is a movement — a tribe of degens, meme-makers, and
            cultural agitators stacking attention until 2028.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            {PILLARS.map((p) => (
              <div
                key={p.title}
                data-testid={`about-pillar-${p.title.toLowerCase().replace(/\s/g, "-")}`}
                className="card-neon p-5"
              >
                <p.icon className="w-5 h-5 text-[#00F0FF] mb-3" />
                <div className="font-heading font-bold text-white text-base">
                  {p.title}
                </div>
                <p className="mt-1.5 text-sm text-white/55 leading-relaxed">
                  {p.body}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT — visual */}
        <div className="relative">
          <div className="relative aspect-square overflow-hidden border border-white/10 rounded-2xl">
            <img
              src={TOKEN_3D}
              alt="3D crypto render"
              className="absolute inset-0 w-full h-full object-cover scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#05050A] via-[#05050A]/40 to-transparent" />
            <div className="absolute inset-0 bg-cyber-grid opacity-25" />
            <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
              <div>
                <div className="font-mono text-[10px] tracking-[0.32em] text-white/60">
                  TICKER
                </div>
                <div className="font-heading text-4xl font-black text-white">
                  $LA28
                </div>
              </div>
              <div className="font-mono text-[10px] tracking-[0.32em] text-[#00F0FF] text-right">
                CHAIN<br />
                <span className="text-white">SOLANA</span>
              </div>
            </div>
          </div>
          <div className="absolute -top-4 -right-4 px-3 py-1 bg-[#FFD700] text-black font-mono text-[10px] tracking-[0.3em] font-bold">
            EST. 2028 ERA
          </div>
        </div>
      </div>
    </section>
  );
}
